import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["isHovered"];
import { CloseIcon as CloseIconLodestar } from "@smartsheet/lodestar-icons";
import { useActive } from "@smartsheet/lodestar-utils";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import { CloseIcon as CloseIconUrsa } from "@smartsheet/ursa-icons";
import React, { forwardRef } from "react";
import { useI18n } from "../../../../i18n/i18n";
import { useHovered } from "../../../../util/useHovered";
import { ActionButton } from "./ActionButton";
export var SelectClearButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useI18n = useI18n(),
    i18n = _useI18n.i18n;
  var themeMode = useCombinedThemeMode();
  var _useHovered = useHovered(),
    isHovered = _useHovered.isHovered,
    useHoveredHandlers = _objectWithoutProperties(_useHovered, _excluded);
  var activeAndHoveredHandlers = useActive(useHoveredHandlers);
  return /*#__PURE__*/React.createElement(ActionButton, _extends({}, activeAndHoveredHandlers, {
    themeMode: themeMode,
    isHovered: isHovered,
    ref: ref,
    "aria-label": i18n._( /*i18n*/{
      comment: "This deselects all the selected values",
      id: "Clear selection"
    }),
    onClick: function onClick(e) {
      var _props$resetFiltering;
      if (props.isMultiSelect) {
        var _props$closeMenu, _props$setActiveIndex, _props$clearSelectedI;
        (_props$closeMenu = props.closeMenu) === null || _props$closeMenu === void 0 ? void 0 : _props$closeMenu.call(props);
        // It's important that we call these two functions in this order.
        // Why? IDK.
        (_props$setActiveIndex = props.setActiveIndex) === null || _props$setActiveIndex === void 0 ? void 0 : _props$setActiveIndex.call(props, -1);
        (_props$clearSelectedI = props.clearSelectedItems) === null || _props$clearSelectedI === void 0 ? void 0 : _props$clearSelectedI.call(props);
      } else {
        props.clearSelection(null);
      }
      // For some reason, focusing this in the current tick causes the
      // setSelectedItems to do nothing.
      requestAnimationFrame(props.refocusTargetElement);
      // Don't let the container handle this.
      e.stopPropagation();
      (_props$resetFiltering = props.resetFiltering) === null || _props$resetFiltering === void 0 ? void 0 : _props$resetFiltering.call(props, "click-select-clear-button");
    }
  }), function () {
    switch (themeMode) {
      case "ursa-light":
        return /*#__PURE__*/React.createElement(CloseIconUrsa, {
          size: 16
        });
      case "lodestar-light":
      case "oldestar":
        return /*#__PURE__*/React.createElement(CloseIconLodestar, null);
    }
  }());
});
SelectClearButton.displayName = "SelectClearButton";
//# sourceMappingURL=SelectClearButton.js.map